import { usePeopleAPI } from "@certn/legacy-api";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useContext } from "react";
import { NavigateOptions, useNavigate, useParams } from "react-router-dom";

import { ApplicationContext } from "./Application.context";

export function useApplicationSections() {
  const { applicantId } = useParams();

  return usePeopleAPI(
    `/internal/people/applicant/${applicantId}/sections/`,
    undefined,
    { revalidateOnFocus: false } // disabling refetch, because it is causing issues with file upload fields
  );
}

export function useSectionNavigation() {
  const { applicantId } = useParams();
  const navigate = useNavigate();
  const { mutate } = useApplicationSections();

  return {
    navigateToSection: async (
      sectionName: string,
      options?: NavigateOptions
    ) => {
      await mutate();
      navigate(`/apply/${applicantId}/${sectionName}`, options);
    },
    navigateToSummary: async () => {
      await mutate();
      navigate(`/apply/${applicantId}/summary`);
    },
  };
}

export function useApplicationField<T>(name: string) {
  const { sections } = useContext(ApplicationContext);

  const allFields = sections.reduce<components["schemas"]["Section"]["fields"]>(
    (fields, section) => {
      return [...fields, ...section.fields];
    },
    []
  );

  return allFields.find((field) => field.name === name) as T;
}

export function useApplicationAddresses() {
  const addressField =
    useApplicationField<components["schemas"]["AddressesCheckField"]>(
      "addresses"
    );

  if (!Array.isArray(addressField?.value)) {
    return [];
  }

  return addressField?.value;
}

export function useApplicationCurrentAddress() {
  const addresses = useApplicationAddresses();
  return addresses.find((address) => !address.end_date);
}
